// src/editar-cadastro.js
import { supabaseClient } from './conection/supabaseClient.js';
import {
    limparNumeros,
    validarCPF,
    validarCNPJ,
    formatarTelefoneInput,
    formatarCPFInput,
    formatarCNPJInput
} from './utils/utils.js';

document.addEventListener('DOMContentLoaded', () => {
    // --- Elementos do Formulário ---
    const editarCadastroForm = document.getElementById('editar-cadastro-form');
    const nomeEditarInput = document.getElementById('nome-editar');
    const telefoneEditarInput = document.getElementById('telefone-editar');
    const telefoneInvalidoDiv = document.getElementById('telefone-invalido-editar');
    const cpfEditarInput = document.getElementById('cpf-editar');
    const cpfInvalidoDiv = document.getElementById('cpf-invalido-editar');
    const empresaEditarInput = document.getElementById('empresa-editar');
    const cnpjEditarInput = document.getElementById('cnpj-editar');
    const cnpjInvalidoDiv = document.getElementById('cnpj-invalido-editar');
    const emailEditarInput = document.getElementById('email-editar');
    const emailInvalidoDiv = document.getElementById('email-invalido-editar');
    const tipoParticipanteRadios = document.querySelectorAll('input[name="tipo-participante-editar"]');
    const tipoParticipanteInvalidoDiv = document.getElementById('tipo-participante-invalido-editar');
    const representanteRadios = document.querySelectorAll('input[name="representante-editar"]'); // NOVO
    const salvarEdicaoButton = document.getElementById('salvar-edicao');
    const cancelarEdicaoButton = document.getElementById('cancelar-edicao');
    const mensagemEdicaoDiv = document.getElementById('mensagem-edicao');
    const buscarCadastroButton = document.getElementById('buscar-cadastro');

    // --- Listeners de Formatação e Validação ---
    telefoneEditarInput?.addEventListener('input', (e) => {
        e.target.value = formatarTelefoneInput(e.target.value);
        if (telefoneInvalidoDiv) telefoneInvalidoDiv.style.display = 'none';
    });
    telefoneEditarInput?.addEventListener('blur', (e) => {
        const tel = limparNumeros(e.target.value);
        if (telefoneInvalidoDiv) {
            if (tel && (tel.length < 10 || tel.length > 11)) {
                telefoneInvalidoDiv.textContent = 'Celular inválido (10 ou 11 dígitos).';
                telefoneInvalidoDiv.style.display = 'block';
            } else {
                telefoneInvalidoDiv.style.display = 'none';
            }
        }
    });

    cpfEditarInput?.addEventListener('input', (e) => {
        e.target.value = formatarCPFInput(e.target.value);
        if (cpfInvalidoDiv) cpfInvalidoDiv.style.display = 'none';
    });
    cpfEditarInput?.addEventListener('blur', (e) => {
        const cpf = limparNumeros(e.target.value);
        if (cpfInvalidoDiv) {
            if (cpf && !validarCPF(cpf)) {
                cpfInvalidoDiv.textContent = 'CPF inválido.';
                cpfInvalidoDiv.style.display = 'block';
            } else {
                cpfInvalidoDiv.style.display = 'none';
            }
        }
    });

    cnpjEditarInput?.addEventListener('input', (e) => {
        e.target.value = formatarCNPJInput(e.target.value);
        if (cnpjInvalidoDiv) cnpjInvalidoDiv.style.display = 'none';
    });
    cnpjEditarInput?.addEventListener('blur', (e) => {
        const cnpj = limparNumeros(e.target.value);
        if (cnpjInvalidoDiv) {
            if (cnpj && !validarCNPJ(cnpj)) {
                cnpjInvalidoDiv.textContent = 'CNPJ inválido.';
                cnpjInvalidoDiv.style.display = 'block';
            } else {
                cnpjInvalidoDiv.style.display = 'none';
            }
        }
    });

    emailEditarInput?.addEventListener('input', () => {
        if (emailInvalidoDiv) emailInvalidoDiv.style.display = 'none';
    });

    // --- Buscar Dados do Participante ---
    async function buscarDadosParticipante(cpf) {
        try {
            const { data: participante, error: selectError } = await supabaseClient
                .from('participantes')
                .select('*')
                .eq('cpf', cpf)
                .maybeSingle();

            if (selectError) {
                throw selectError;
            }

            if (participante) {
                nomeEditarInput.value = participante.nome;
                telefoneEditarInput.value = participante.telefone;
                cpfEditarInput.value = participante.cpf || '';
                empresaEditarInput.value = participante.empresa || '';
                cnpjEditarInput.value = participante.cnpj || '';
                emailEditarInput.value = participante.email;
                tipoParticipanteRadios.forEach(radio => {
                    radio.checked = (radio.value === participante.tipo_participante);
                });
                representanteRadios.forEach(radio => { // NOVO
                    radio.checked = (radio.value === String(participante.representante)); // NOVO
                }); // NOVO

                nomeEditarInput.disabled = false;
                telefoneEditarInput.disabled = false;
                empresaEditarInput.disabled = false;
                cnpjEditarInput.disabled = false;
                emailEditarInput.disabled = false;
                tipoParticipanteRadios.forEach(radio => radio.disabled = false);
                representanteRadios.forEach(radio => radio.disabled = false); // NOVO
                salvarEdicaoButton.disabled = false;

                mensagemEdicaoDiv.textContent = 'Dados carregados. Faça as alterações e salve.';
                mensagemEdicaoDiv.style.color = 'green';
            } else {
                mensagemEdicaoDiv.textContent = 'Participante não encontrado.';
                mensagemEdicaoDiv.style.color = 'orange';
                limparEdesabilitarFormulario();
            }
        } catch (error) {
            mensagemEdicaoDiv.textContent = `Erro ao buscar dados: ${error.message}`;
            mensagemEdicaoDiv.style.color = 'red';
            limparEdesabilitarFormulario();
        }
    }

    function limparEdesabilitarFormulario() {
        nomeEditarInput.value = '';
        telefoneEditarInput.value = '';
        cpfEditarInput.value = '';
        empresaEditarInput.value = '';
        cnpjEditarInput.value = '';
        emailEditarInput.value = '';
        tipoParticipanteRadios.forEach(radio => radio.checked = false);
        representanteRadios.forEach(radio => radio.checked = false); // NOVO

        nomeEditarInput.disabled = true;
        telefoneEditarInput.disabled = true;
        empresaEditarInput.disabled = true;
        cnpjEditarInput.disabled = true;
        emailEditarInput.disabled = true;
        tipoParticipanteRadios.forEach(radio => radio.disabled = true);
        representanteRadios.forEach(radio => radio.disabled = true); // NOVO
        salvarEdicaoButton.disabled = true;
    }

    buscarCadastroButton?.addEventListener('click', (event) => {
        event.preventDefault();
        const cpf = limparNumeros(cpfEditarInput.value);

        if (!cpf || !validarCPF(cpf)) {
            mensagemEdicaoDiv.textContent = 'Por favor, insira um CPF válido.';
            mensagemEdicaoDiv.style.color = 'red';
            return;
        }

        mensagemEdicaoDiv.textContent = 'Buscando cadastro...';
        mensagemEdicaoDiv.style.color = 'black';
        buscarDadosParticipante(cpf);
    });

    // --- Salvar Edição ---
    salvarEdicaoButton?.addEventListener('click', async () => {
        let hasError = false;
        let errorMessages = [];

        if (!nomeEditarInput.value) errorMessages.push('Nome é obrigatório.');
        if (!telefoneEditarInput.value) {
            errorMessages.push('Celular é obrigatório.');
        } else if (limparNumeros(telefoneEditarInput.value).length < 10 || limparNumeros(telefoneEditarInput.value).length > 11) {
            if (telefoneInvalidoDiv) {
                telefoneInvalidoDiv.textContent = 'Celular inválido (10 ou 11 dígitos).';
                telefoneInvalidoDiv.style.display = 'block';
            }
            hasError = true;
        }
        if (!emailEditarInput.value) {
            errorMessages.push('Email é obrigatório.');
        } else {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(emailEditarInput.value)) {
                if (emailInvalidoDiv) {
                    emailInvalidoDiv.textContent = 'Formato de email inválido.';
                    emailInvalidoDiv.style.display = 'block';
                }
                hasError = true;
            }
        }
        if (cpfEditarInput.value && !validarCPF(limparNumeros(cpfEditarInput.value))) {
            if (cpfInvalidoDiv) {
                cpfInvalidoDiv.textContent = 'CPF inválido.';
                cpfInvalidoDiv.style.display = 'block';
            }
            hasError = true;
        }
        if (cnpjEditarInput.value && !validarCNPJ(limparNumeros(cnpjEditarInput.value))) {
            if (cnpjInvalidoDiv) {
                cnpjInvalidoDiv.textContent = 'CNPJ inválido.';
                cnpjInvalidoDiv.style.display = 'block';
            }
            hasError = true;
        }
        let tipoParticipanteSelecionado = false;
        tipoParticipanteRadios.forEach(radio => {
            if (radio.checked) tipoParticipanteSelecionado = true;
        });
        if (!tipoParticipanteSelecionado) {
            if (tipoParticipanteInvalidoDiv) tipoParticipanteInvalidoDiv.style.display = 'block';
            hasError = true;
        }

        if (errorMessages.length > 0 && mensagemEdicaoDiv) {
            mensagemEdicaoDiv.textContent = errorMessages.join(' ');
            mensagemEdicaoDiv.style.color = 'red';
            hasError = true;
        }

        if (hasError) return;

        const nome = nomeEditarInput.value;
        const telefone = limparNumeros(telefoneEditarInput.value);
        const cpf = limparNumeros(cpfEditarInput.value) || null;
        const empresa = empresaEditarInput.value || null;
        const cnpj = limparNumeros(cnpjEditarInput.value) || null;
        const email = emailEditarInput.value;
        let tipoParticipante = '';
        tipoParticipanteRadios.forEach(radio => {
            if (radio.checked) tipoParticipante = radio.value;
        });
        let representante = null; // NOVO
        representanteRadios.forEach(radio => { // NOVO
            if (radio.checked) { // NOVO
                representante = radio.value === 'true'; // NOVO
            } // NOVO
        }); // NOVO

        try {
            const { error: updateError } = await supabaseClient
                .from('participantes')
                .update({
                    nome: nome,
                    telefone: telefone,
                    cpf: cpf,
                    empresa: empresa,
                    cnpj: cnpj,
                    email: email,
                    tipo_participante: tipoParticipante,
                    representante: representante // NOVO
                })
                .eq('cpf', cpf);

            if (updateError) {
                throw updateError;
            }

            mensagemEdicaoDiv.textContent = 'Dados atualizados com sucesso!';
            mensagemEdicaoDiv.style.color = 'green';
        } catch (error) {
            mensagemEdicaoDiv.textContent = `Erro ao atualizar dados: ${error.message}`;
            mensagemEdicaoDiv.style.color = 'red';
        }
    });

    cancelarEdicaoButton?.addEventListener('click', () => {
        window.location.href = 'index.html';
    });

    const urlParams = new URLSearchParams(window.location.search);
    const cpfNaUrl = urlParams.get('cpf');
    if (cpfNaUrl) {
        cpfEditarInput.value = cpfNaUrl;
        buscarDadosParticipante(cpfNaUrl);
    }
});